import React from "react";
import { Provider } from "react-redux";
import { HashRouter, BrowserRouter } from "react-router-dom";
import App from './app';
import { ScrollToTop } from "./pageComponents";


const Root = ({ store }) => {
  return (
    <Provider store={store}>
      <BrowserRouter>
        <ScrollToTop />
         <App />
      </BrowserRouter>
    </Provider>
  )
};

export default Root;